/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlock_TitleInputs */

const en_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock Record`)
};

const fr_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deverrouiller l'enregistrement`)
};

const de_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entsperrdatensatz`)
};

const it_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca record`)
};

const ru_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать запись`)
};

const es_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear registro`)
};

const zh_cn2_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁记录`)
};

const ja_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードのロックを解除`)
};

const hi_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड अनलॉक करें`)
};

const pt_pt2_explorer_info_unlock_title = /** @type {(inputs: Explorer_Info_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear registro`)
};

/**
* | output |
* | --- |
* | "Unlock Record" |
*
* @param {Explorer_Info_Unlock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_title = /** @type {((inputs?: Explorer_Info_Unlock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_unlock_title(inputs)
	if (locale === "de") return de_explorer_info_unlock_title(inputs)
	if (locale === "it") return it_explorer_info_unlock_title(inputs)
	if (locale === "ru") return ru_explorer_info_unlock_title(inputs)
	if (locale === "es") return es_explorer_info_unlock_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_unlock_title(inputs)
	if (locale === "ja") return ja_explorer_info_unlock_title(inputs)
	if (locale === "hi") return hi_explorer_info_unlock_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_unlock_title(inputs)
	return en_explorer_info_unlock_title(inputs)
});